import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=22b3812f"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=22b3812f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b3812f')) {
      api.createRecord('22b3812f', component.options)
    } else {
      api.reload('22b3812f', component.options)
    }
    module.hot.accept("./ConfirmationDialog.vue?vue&type=template&id=22b3812f", function () {
      api.rerender('22b3812f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ConfirmationDialog.vue"
export default component.exports